import { render, staticRenderFns } from "./DialogAssignUser.vue?vue&type=template&id=27557962"
import script from "./DialogAssignUser.vue?vue&type=script&lang=js"
export * from "./DialogAssignUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports